"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncActionMethods = void 0;
var AsyncActionMethods;
(function (AsyncActionMethods) {
    AsyncActionMethods["Error"] = "error";
    AsyncActionMethods["Failed"] = "failed";
    AsyncActionMethods["Receive"] = "receive";
    AsyncActionMethods["Repeat"] = "repeat";
    AsyncActionMethods["Request"] = "request";
    AsyncActionMethods["Reset"] = "reset";
})(AsyncActionMethods || (exports.AsyncActionMethods = AsyncActionMethods = {}));
//# sourceMappingURL=ActionMethods.js.map